import { usePromotionAddAllAvailability } from '../hooks/catalog/usePromotionAddAllAvailability'

/**
 * Renders nothing; mounts the stock check behind the promotion add-all
 * buttons once for the whole app. It sits beside the route table rather than
 * in a template because the buttons render on containers of any type, and a
 * per-container mount would send one request per container.
 */
const PromotionAddAllAvailability = () => {
  usePromotionAddAllAvailability()
  return null
}

export default PromotionAddAllAvailability
